<template>
  <v-snackbar v-model="showSnackbar" color="error" multi-line bottom :timeout="0">
    <ul class="pa-0 flex-shrink-1">
      <li
        v-for="(error, index) in formErrorStrings"
        :key="index"
        :class="['ml-0', $style['list-item'], { 'mb-0': index === formErrors.length - 1 }]"
      >
        {{ error }}
      </li>
    </ul>

    <v-btn color="black" text small @click="showSnackbar = false">{{ $t('general.close') }}</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

import formValidationErrorMixin from '@/js/components/Forms/mixins/form-validation-error-mixin.js'

export default {
  name: 'ComplaintFormErrorSnackbar',
  mixins: [formValidationErrorMixin],
  data() {
    return {
      showSnackbar: false,
    }
  },
  computed: {
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      formErrors: FORM_GETTER.FORM_ERRORS,
    }),
  },
  watch: {
    formErrors() {
      if (this.formErrors.length === 0) {
        this.showSnackbar = false

        return this.showSnackbar
      }

      if (!this.showSnackbar && this.formErrors.length > 0) {
        this.showSnackbar = true

        return this.showSnackbar
      }
    },
  },
}
</script>

<style lang="scss" module>
.list-item {
  word-break: break-all;
}
</style>
